import { useQuery } from "@tanstack/react-query";
import { SecurityAppAIConfig } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import useLicenseCheck from "license/useLicenseCheck";
export const AI_CONFIGURATION_QUERY_STRING = "ai-configuration";
const getAIReportConfiguration = () => SecurityAppAIConfig.aiClusterConfig().then((response) => ({
  isEnabled: (response == null ? void 0 : response.ai_enabled) !== false
}));
const useAIConfiguration = () => {
  const {
    security: { isValid: validSecurityLicense },
    enterprise: { isValid: validEnterpriseLicense }
  } = useLicenseCheck();
  const hasValidLicense = validSecurityLicense || validEnterpriseLicense;
  const { data, isLoading } = useQuery({
    queryKey: [AI_CONFIGURATION_QUERY_STRING],
    queryFn: () => defaultOnError(
      getAIReportConfiguration(),
      "Fetching AI Configuration with status",
      "Could not fetch AI Configuration"
    ),
    enabled: hasValidLicense
  });
  return {
    data: data != null ? data : {
      isEnabled: false
    },
    isLoading
  };
};
export default useAIConfiguration;
